import { render, staticRenderFns } from "./after-buy.vue?vue&type=template&id=2cf32425&scoped=true&"
import script from "./after-buy.vue?vue&type=script&lang=ts&"
export * from "./after-buy.vue?vue&type=script&lang=ts&"
import style0 from "./after-buy.vue?vue&type=style&index=0&id=2cf32425&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf32425",
  null
  
)

export default component.exports